/**
 * Month-period helpers (YYYY-MM) shared across the admin dashboards that offer a
 * month selector — CostReportPage and UsageHealthPage today. All UTC so the
 * displayed period matches the backend's UTC period bucketing exactly.
 *
 * NOTE: ExportPage intentionally keeps its own local-time, count-parameterized,
 * 90-day-retention-limited variant — its month boundary semantics differ and
 * unifying it would be a behaviour change, not a refactor.
 */

/** Current month as a YYYY-MM string (UTC). */
export function getCurrentPeriod(): string {
  const d = new Date();
  return `${d.getUTCFullYear()}-${String(d.getUTCMonth() + 1).padStart(2, '0')}`;
}

/** Last `count` months (default 12) as YYYY-MM strings, newest first (UTC). */
export function getRecentPeriods(count: number = 12): string[] {
  const out: string[] = [];
  const now = new Date();
  for (let i = 0; i < count; i++) {
    const d = new Date(Date.UTC(now.getUTCFullYear(), now.getUTCMonth() - i, 1));
    out.push(`${d.getUTCFullYear()}-${String(d.getUTCMonth() + 1).padStart(2, '0')}`);
  }
  return out;
}

/** "2026-04" -> "April 2026". Returns the raw string if unparseable. */
export function formatPeriodLabel(period: string): string {
  const [yearStr, monthStr] = period.split('-');
  const year = Number(yearStr);
  const month = Number(monthStr);
  if (!Number.isFinite(year) || !Number.isFinite(month)) return period;
  const d = new Date(Date.UTC(year, month - 1, 1));
  return d.toLocaleDateString('en-US', { month: 'long', year: 'numeric', timeZone: 'UTC' });
}
